import moment from "moment";

export function isModuleActive(data, moduleName) {
  let active = false;
  data.map(item => {
    if (item.name === moduleName) {
      active = item.active;
    }
  });
  return active;
}

export function getCurrentMonthAndYear(day) {
  return moment(day).format("MMMM YYYY");
}
